module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": ("vux-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.initialShow),
      expression: "show && !initialShow"
    }],
    staticClass: "vux-popup-dialog",
    class: [("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],
    style: (_vm.styles)
  }, [(_vm.shouldRenderBody) ? _vm._t("default") : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65680213!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/popup/index.vue
// module id = 400
// module chunks = 36